<template>
<div>
	<pagesHeading :path2="category.name" />
	<div id="products" class="row m-0 d-flex justify-content-center"  :class="{ 'loading-app-style': loading }">
		<div class="col-11">
			<div v-if="loading" class="py-4" style="display: flex; align-items: center; justify-content: center">
				<div  class="loader"></div>
			</div>
			<div v-else class="row mt-5">
				<div
					v-for="(product, key) in productForCategory"
					:key="key"
					class="col-sm-6 col-lg-4 col-12 d-flex justify-content-center"
					style="margin-top:10vh; margin-bottom:5vh"
				>
					<div class="card" style="width: 18rem;">
						<div class="card-body">
							<router-link :to="{name: 'product-view', params: {productSlug: product.slug, categorySlug: $route.params.slug} }" class="no-decoration">
									<img :src="product.primaryImage.url" class="img-fluid cover same-height">
							</router-link>
						</div>
						<div class="container card-product-content">
							<h5 class="card-title text-center font-weight-bold"> {{ product.name }}</h5>
							<div
								v-html="product.description" 
								class="card-text text-center"
							></div>
						</div>
						<router-link
							:to="{name: 'product-view', params: {productSlug: product.slug, categorySlug: $route.params.slug} }"  style="text-decoration: none !important"
						>
							<button class="read-more">{{$t('common.read-more')}}</button>
						</router-link>
					</div>
				</div>
		
			</div>
		</div>
	</div>
</div>

</template>
<script>
import { mapState, mapActions } from 'vuex';
import pagesHeading from '../components/PagesHeading.vue'
export default {
	components: {
		pagesHeading
	},
	data() {
		return {
			loading: true,
		}
	},
	computed: {
		...mapState({
			productForCategory: state => state.products.products,
			categories: state => state.categories.categories
		}),
		category () {
			if (this.categories[0]) {
				return this.categories.find(t => t.slug === this.$route.params.slug);
			} else {
				return '';
			}
		}
	},
	methods: {
		...mapActions('products', ['fetchProducts']),
		...mapActions('categories', ['fetchCategories']),
		fetch() {
			this.fetchProducts(this.$route.params.slug)
				.finally(() => { this.loading = false });
			if (!this.categories[0]) {
				this.fetchCategories();
			}
		}
	},
	created() {
		this.fetch();
	}
}
</script>
<style scoped>
body {
	background-color: #fff;
}
.card {
	background: url('../../public/images/products-background-opacity.png');
	background-color: #e9e8e4;
	background-size: 100%;
	background-repeat: no-repeat;
	background-position: top right;
	border-radius: 18px;
	border:0px;
	box-shadow: -1px 2px 8px rgba(0, 0, 0, 0.25);
	height: 450px;
	transition: all 0.5s ease, transform 0.5s ease;
	
}

.card:hover {
	background-color: #FCAD4D;
	transform: scale(1.1);
	box-shadow: -1px 2px 18px rgba(0, 0, 0, 0.25);

}

.card-body h3 {
	margin-top: 3vh;
}

.card-body img {
	position: absolute;
	top: -52px;
	bottom: 0;
	left: calc(50% - 84px);
}

.card-body {
	flex: 0.5 0.5 auto;
	padding: 1.25rem;
}

.card-product-content {
	color: #7e7e7e;
}

.read-more {
	display: none;
}
.card-text * {
	background-color: transparent;
}
.card:hover a {
	display: flex;
	justify-content: center;
}

.card:hover .read-more  {
	display: flex;
	border: 1px solid #fff;
	color: #FCAD4D;
	border-radius: 30px;
	padding: 4px 60px;
	background-color: #fff;
	margin-top: 8vh;
	justify-content: center;
}

a {
	text-decoration: none !important;
}

.card:hover .card-product-content {
	color: #fff;
	margin-top: 10vh;
}

.card:hover .card-text {
	color: #fff;
}

.card:hover .card-text p {
	color: #fff;
}

img.same-height {
	height: 200px;
}

.cover {
	object-fit: cover;
}
</style>